import { IonContent } from '@ionic/react';
import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { canLogEvents } from '@/utils/canLogEvents';

import { ContentContainer, PageStyles, Subtitle } from './SummaryFinal.styles';

export const SummaryFinal: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Summary Final',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <PageStyles background="domination">
      <IonContent>
        <ContentContainer>
          <Player
            src="/assets/layout-own-ai-dominate/summary_screens/summary_final.json"
            autoplay
            loop={false}
            keepLastFrame
          />
          <OwnAiTitle className={'title'}>The ritual is ready.</OwnAiTitle>
          <Subtitle color={'neutral-white'}>
            Prepare yourself for my next move.
          </Subtitle>
        </ContentContainer>
      </IonContent>

      <OnboardingFooter
        onContinue={handleNextStep}
        buttonColor={'red-gradient'}
        buttonRadius={'sm'}
        buttonSize={'medium'}
      />
    </PageStyles>
  );
};
